export const saturdayUppercase = "xqa";
export default {saturdayUppercase};